"use client";

import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Admin consent popup callback. After the user grants consent in the Microsoft page,
 * Entra redirects here with admin_consent and tenant. We notify the opener and close.
 */
export default function AdminConsentCallbackPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const adminConsent = searchParams.get("admin_consent");
    const tenant = searchParams.get("tenant") ?? "";
    const error = searchParams.get("error");

    if (window.opener) {
      window.opener.postMessage(
        {
          type: "resilience365-admin-consent",
          success: adminConsent === "True",
          tenant: tenant || undefined,
          error: error || undefined,
        },
        window.location.origin
      );
    }
    window.close();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <p className="text-sm text-muted-foreground">Closing window…</p>
    </div>
  );
}
